import type {ReactElement} from 'react';
import {SkeletonBrick} from '@Components/skeleton-brick';
import {
  PREVIEW_SKELETON_ACCOUNT_META_HEIGHT,
  PREVIEW_SKELETON_ACCOUNT_META_WIDTH,
  PREVIEW_SKELETON_ACCOUNT_NAME_HEIGHT,
  PREVIEW_SKELETON_ACCOUNT_NAME_WIDTH,
  PREVIEW_SKELETON_ACTION_HEIGHT,
  PREVIEW_SKELETON_AVATAR_SIZE,
  PREVIEW_SKELETON_BADGE_RADIUS,
  PREVIEW_SKELETON_BADGE_SIZE,
  PREVIEW_SKELETON_BLOCK_RADIUS,
  PREVIEW_SKELETON_CAPTION_HEIGHT,
  PREVIEW_SKELETON_CAPTION_LAST_LINE_WIDTH,
  PREVIEW_SKELETON_LEADING_ACTION_WIDTH,
  PREVIEW_SKELETON_TRAILING_ACTION_WIDTH,
} from './social-post-preview-skeleton.types';
import type {SocialPostPreviewSkeletonProps} from './social-post-preview-skeleton.types';
import styles from './social-post-preview-skeleton.module.scss';

export function SocialPostPreviewSkeleton({cardStyle}: SocialPostPreviewSkeletonProps): ReactElement {
  const getAccountHeader = (): ReactElement => {
    return (
      <div className={styles.previewSkeletonHeader}>
        <div className={styles.previewSkeletonIdentity}>
          <SkeletonBrick width={PREVIEW_SKELETON_AVATAR_SIZE} height={PREVIEW_SKELETON_AVATAR_SIZE} radius="50%" />
          <div className={styles.previewSkeletonIdentityText}>
            <SkeletonBrick width={PREVIEW_SKELETON_ACCOUNT_NAME_WIDTH} height={PREVIEW_SKELETON_ACCOUNT_NAME_HEIGHT} radius={PREVIEW_SKELETON_BLOCK_RADIUS} />
            <SkeletonBrick width={PREVIEW_SKELETON_ACCOUNT_META_WIDTH} height={PREVIEW_SKELETON_ACCOUNT_META_HEIGHT} radius={PREVIEW_SKELETON_BLOCK_RADIUS} />
          </div>
        </div>
        <SkeletonBrick width={PREVIEW_SKELETON_BADGE_SIZE} height={PREVIEW_SKELETON_BADGE_SIZE} radius={PREVIEW_SKELETON_BADGE_RADIUS} />
      </div>
    );
  };

  const getCaptionLines = (): ReactElement => {
    return (
      <div className={styles.previewSkeletonCaption}>
        <SkeletonBrick height={PREVIEW_SKELETON_CAPTION_HEIGHT} radius={PREVIEW_SKELETON_BLOCK_RADIUS} />
        <SkeletonBrick width={PREVIEW_SKELETON_CAPTION_LAST_LINE_WIDTH} height={PREVIEW_SKELETON_CAPTION_HEIGHT} radius={PREVIEW_SKELETON_BLOCK_RADIUS} />
      </div>
    );
  };

  const getActionRow = (): ReactElement => {
    return (
      <div className={styles.previewSkeletonActions}>
        <SkeletonBrick width={PREVIEW_SKELETON_LEADING_ACTION_WIDTH} height={PREVIEW_SKELETON_ACTION_HEIGHT} radius={PREVIEW_SKELETON_BLOCK_RADIUS} />
        <SkeletonBrick width={PREVIEW_SKELETON_TRAILING_ACTION_WIDTH} height={PREVIEW_SKELETON_ACTION_HEIGHT} radius={PREVIEW_SKELETON_BLOCK_RADIUS} />
      </div>
    );
  };

  return (
    <div className={`${styles.previewSkeletonOverlay} ${cardStyle ? styles.previewSkeletonOverlayFixedCard : ''}`} aria-hidden="true">
      <div className={`${styles.previewSkeletonCard} ${cardStyle ? styles.previewSkeletonCardFixed : ''}`} style={cardStyle}>
        {getAccountHeader()}
        {getCaptionLines()}
        <SkeletonBrick className={styles.previewSkeletonMedia} radius="0" />
        {getActionRow()}
      </div>
    </div>
  );
}
